import { useEffect } from "react";
import { createUpdateEffect } from "./useUpdateEffect";

export const useUpdateEffect = createUpdateEffect(useEffect);

export { createUpdateEffect };
